import { useEffect } from 'react';
import { useAuth } from '@clerk/clerk-react';
import { setTokenGetter } from '../api/client';

/**
 * Configures the API client to send the Clerk session token with requests.
 * Must be rendered inside ClerkProvider.
 */
const ApiClientConfig = () => {
  const { getToken } = useAuth();

  useEffect(() => {
    setTokenGetter(() => getToken());
  }, [getToken]);

  return null;
};

export default ApiClientConfig;
